import { memo, useCallback, useState } from 'react';
import {
  WhatsappShareButton,
  TelegramShareButton,
  VKShareButton,
  FacebookShareButton,
} from 'react-share';

import SmartRender from '@Components/SmartRender';
import { useDeps } from '@Contexts/DI';
import styles from './Share.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ShareProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Share: FC<ShareProps> = (props) => {
  const [url, setUrl] = useState('');
  const { analytics } = useDeps();

  const handleClick = useCallback(
    (link) => {
      analytics.dispatchEvent('link.external.click', { link });
    },
    [analytics],
  );

  const handleMouseEnter = useCallback(() => {
    setUrl(window.location.href);
  }, []);

  return (
    <div {...props} onMouseEnter={handleMouseEnter}>
      <VKShareButton
        url={url}
        className={styles.shareButton}
        onClick={() => handleClick('VKShareLink')}
      >
        <div className={styles.VKIcon} />
      </VKShareButton>
      <SmartRender countries={['BLR', 'KAZ', 'UZB']}>
        <FacebookShareButton
          url={url}
          className={styles.shareButton}
          onClick={() => handleClick('FacebookShareLink')}
        >
          <div className={styles.faceBookIcon} />
        </FacebookShareButton>
      </SmartRender>
      <TelegramShareButton
        url={url}
        className={styles.shareButton}
        onClick={() => handleClick('TelegramShareLink')}
      >
        <div className={styles.telegramIcon} />
      </TelegramShareButton>
      <WhatsappShareButton
        url={url}
        className={styles.shareButton}
        onClick={() => handleClick('WhatsappShareLink')}
      >
        <div className={styles.whatsappIcon} />
      </WhatsappShareButton>
    </div>
  );
};

export default memo(Share);
